var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEsquemasInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#8a8a8a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_7",
    "data-name": "Capa 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bounding_Boxes",
    "data-name": "Bounding Boxes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2274",
    "data-name": "Trazado 2274",
    className: "cls-1",
    d: "M3.26-8.39h24v24h-24Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_22",
    "data-name": "Capa 22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2543",
    "data-name": "Trazado 2543",
    className: "cls-2",
    d: "M2,3.36V19.64a1.19,1.19,0,0,0,1.2,1.19H19.78A1.19,1.19,0,0,0,21,19.64V3.36a1.19,1.19,0,0,0-1.2-1.19H3.22A1.19,1.19,0,0,0,2,3.36ZM6.48,4.67v3H3.9v-3ZM3.9,13V10H6.48v3Zm0,2.33H6.48v3H3.9Zm15.29,3h-11v-3h11Zm0-5.33h-11V10h11Zm0-5.33h-11v-3h11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEsquemasInactive);
export default __webpack_public_path__ + "static/media/ic-esquemas-inactive.420f7e84be49b8f8a6454c9966bf967a.svg";
export { ForwardRef as ReactComponent };